import { Controller } from "@hotwired/stimulus"

// No jQuery needed - just calls global vendor functions
export default class extends Controller {
  connect() {
    // These functions are defined in app/frontend/vendor/
    // They set up accordion slide animations and keyboard shortcuts
    // (They use jQuery internally via noConflict, but we don't need it here)
    if (typeof custom_accordion_slide === 'function') {
      custom_accordion_slide()
    }
    if (typeof custom_acc_key_mouse === 'function') {
      custom_acc_key_mouse()
    }
  }
}
